
import { Component, Vue } from "vue-property-decorator";
import { InquirySheet } from "./types";
import Pagination from "@/components/Pagination/index.vue";
import History from "./components/History.vue";
import { COMPANY_OPTIONS, QUOTED_STATUS } from "@/constant";
import {
  getInquirySheetDetail,
  getInquirySheetOrderStatus,
  getNumberTypes,
  addInquirySheetRemark,
  deleteInquirySheetDetail,
  exportInquirySheetPackageInfo,
  createInquirySheetPI,
  saveInquirySheetDetail,
  exportInquirySheetDetail,
  getInquirySheetPiPei,
  getInquirySheetState,
  downloadCheckQuotation,
  addNumberType,
  getProductNumberExtends,
  constcheckWhetherItCanBeSaved,
  getInquirySheet,
  getExtend
} from "@/api/inquiry";
import LookRemark from "./components/lookRemark.vue"
import PiHistoryPrice from "./components/PiHistoryPrice.vue"
import {UserModule} from "@/store/modules/user";

@Component({
  name: "enquiryQuotationDetails",
  components: {
    Pagination,
    History,
    LookRemark,
    PiHistoryPrice,
  },
})
export default class extends Vue {
  public productNumberId = '';
  public remarkInfo = [] as any;
  public show_remark = false;
  public showEditRemark = false;
  public editRemark = '';
  public editRemarkRow = null as any;
  public dialogVisible: Boolean = false;
  // 提示框
  private showNotice = false;
  // 是否显示所有产品号码
  private isShowMore = false;
  private isShowMore2 = false;
  private isShowMore3 = false;
  private showHistory = false;
  private showPiHistoryPrice = false;
  private piHistoryMeta = {
    numberType: "",
    number: "",
  };
  private piHistoryQuery = {} as Record<string, any>;
  private saveBJLoading = false;
  private saveDownloadLoading = false;
  private createPITrue = true;
  private updateInquirySheetByUploadAccountType = 'A';
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  private listParam = {
    inquirySheetId: null,
    refNumber: null,
    refTypeId: null,
    quotedStatus: null,
    orderStatus: null,
    supplier: null,
    hqProductName: null,
    type: null,
    customerAbbreviation: null,
  };
  private inquirySheetId = "";
  private listItem = {} as InquirySheet;
  public FormItem: Array<any> = [
    {
      label: "号码类型",
      prop: "typeId",
      type: "select",
      placeholder: "请选择",
      options: [],
    },
    {
      label: "号码",
      prop: "numbers",
      type: "input",
      placeholder: "请输入号码内容",
    },
  ];
  public InitialForm = {
    numbers: "",
    typeId: "",
  };
  public detailId = "";
  public openDialog(e: any) {
    this.dialogVisible = true;
    this.detailId = e.row.detailId;
  }
  public createModel() {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            const form: any = this.$refs.ruleForm;
            await addNumberType(this.detailId, form.Form).then(res => {
              this.$notify({
                title: "提示",
                message: '操作成功！',
                type: "success",
              });
              this.getList(false);
            }).catch(err => {
              console.log(err)
            });
            form.$refs.ruleForm.resetFields();
          } catch (error) {
            console.error(error);
          }
        }
        this.dialogVisible = false;
      }
    );
  }
  public searchForm = [
    {
      label: "产品型号",
      prop: "refNumber",
      key: "refNumber",
      type: "input",
      value: "",
      placeholder: "请输入产品型号",
    },
    {
      label: "搜索类型",
      prop: "refTypeId",
      key: "refTypeId",
      type: "select",
      value: "",
      placeholder: "选择搜索类型",
      options: [],
    },
    {
      label: "结果筛选",
      prop: "quotedStatus",
      key: "quotedStatus",
      type: "select",
      value: "",
      placeholder: "全部",
      options: QUOTED_STATUS,
    },
    {
      label: "结果筛选",
      prop: "orderStatus",
      key: "orderStatus",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
  ];
  private inquiryStatus = null;
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: "left",
      disabled: false,
      width: 55,
    },
    {
      label: "询价参照号",
      prop: "refNumber",
      key: "refNumber",
      show: true,
      disabled: false,
      width: 130,
    },
    {
      label: "询价参照类型",
      prop: "refType",
      key: "refType",
      show: true,
      disabled: false,
      width: 110,
    },
    {
      label: "品牌名称",
      prop: "brandName",
      key: "brandName",
      show: true,
      disabled: false,
      width: 100,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
      width: 110,
    },
    {
      label: "PRODUCT NAME",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 130,
    },
    {
      label: "DESCRIPTION1",
      prop: "description1",
      key: "description1",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 120,
    },
    {
      label: "产品属性1",
      prop: "productAttributes1",
      key: "productAttributes1",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 90,
    },
    {
      label: "DESCRIPTION2",
      prop: "description2",
      key: "description2",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 120,
    },
    {
      label: "产品属性2",
      prop: "productAttributes2",
      key: "productAttributes2",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 90,
    },
    {
      label: "DESCRIPTION3",
      prop: "description3",
      key: "description3",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 120,
    },
    {
      label: "产品属性3",
      prop: "productAttributes3",
      key: "productAttributes3",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 90,
    },
    {
      label: "DESCRIPTION4",
      prop: "description4",
      key: "description4",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 120,
    },
    {
      label: "产品属性4",
      prop: "productAttributes4",
      key: "productAttributes4",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 90,
    },
    {
      label: "工艺",
      prop: "technicDesc",
      key: "technicDesc",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 80,
    },
    {
      label: "technic",
      prop: "technic",
      key: "technic",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 90,
    },
    {
      label: "产品信息",
      prop: "productInfoDesc",
      key: "productInfoDesc",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 100,
    },
    {
      label: "Product Info",
      prop: "productInfo",
      key: "productInfo",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 110,
    },
    {
      label: "车型/Car Application",
      prop: "carApplication",
      key: "carApplication",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 150,
    },
    {
      label: "装箱数（客）",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 100,
    },
    {
      label: "装托数（客）",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false,
      show_key: "show2",
      width: 100,
    },
    {
      label: "下单状态",
      prop: "orderStatus",
      key: "orderStatus",
      show: true,
      disabled: false,
      width: 90,
    },
    {
      label: "数量",
      prop: "productQuantity",
      key: "productQuantity",
      show: true,
      disabled: false,
      width: 70,
    },
    {
      label: "供应商名称",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
      width: 110,
    },
    {
      label: "采购原价",
      headerSub: "（RMB）",
      prop: "originalPurchaseUnitPrice",
      key: "originalPurchaseUnitPrice",
      show: true,
      disabled: false,
      width: 90,
    },
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      show: true,
      disabled: false,
      width: 80,
    },
    {
      label: "采购折后单价",
      headerSub: "（RMB）",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      show: true,
      disabled: false,
      width: 100,
    },
    {
      label: "单价类型",
      prop: "unitPriceType",
      key: "unitPriceType",
      show: true,
      disabled: false,
      show_key: "show3",
      width: 90,
    },
    {
      label: "目录价格(DMS)",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false,
      show_key: "show3",
      width: 110,
    },
    {
      label: "供应商选择偏好",
      prop: "selectSupplierCriteria",
      key: "selectSupplierCriteria",
      show: true,
      disabled: false,
      show_key: "show3",
      width: 120,
    },
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      show: true,
      disabled: false,
      show_key: "show3",
      width: 80,
    },
    {
      label: "报价来源",
      prop: "sourceOfQuote",
      key: "sourceOfQuote",
      show: true,
      disabled: false,
      show_key: "show3",
      account: ['A','A_B'],
      width: 90,
    },
    {
      label: "销售原价",
      headerSub: "（USD）",
      prop: "originalSaleUnitPrice",
      key: "originalSaleUnitPrice",
      show: true,
      disabled: false,
      account: ['A','A_B'],
      width: 90,
    },
    {
      label: "公司定价",
      prop: "companyPrice",
      key: "companyPrice",
      show: true,
      disabled: false,
      account: ['B','A_B'],
      width: 90,
    },
    {
      label: "销售折扣",
      prop: "saleDiscount",
      key: "saleDiscount",
      show: true,
      disabled: false,
      width: 80,
    },
    {
      label: "销售折后单价",
      headerSub: "（USD）",
      prop: "saleUnitPrice",
      key: "saleUnitPrice",
      show: true,
      disabled: false,
      account: ['A','A_B'],
      width: 100,
    },
    {
      label: "销售折扣",
      prop: "saleDiscount",
      key: "saleDiscount",
      show: true,
      disabled: false,
      show_key: "show3",
      width: 80,
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      show: true,
      disabled: false,
      show_key: "show3",
      width: 70,
    },
    {
      label: "客人报价来源",
      prop: "sourceOfCustomerQuote",
      key: "sourceOfCustomerQuote",
      show: true,
      disabled: false,
      show_key: "show3",
      account: ['A','A_B'],
      width: 110,
    },
    {
      label: "折算利润率",
      prop: "conversionProfitMargin",
      key: "conversionProfitMargin",
      show: true,
      disabled: false,
      account: ['A','A_B'],
      width: 90,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
      width: 90,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
        {
          name: "查看备注",
          code: '',
          click: "handlerSeeRemark"
        },
        { name: "查看历史报价单",
          code: "",
          account: ['A','A_B'],
          click: "handleHistory",
        },
        { name: "新增型号", code: "", click: "createModel",type: 'render' }
      ],
      show: true,
      disabled: false,
      width: 320,
    },
  ] as any;
  get visibleTableCol() {
    return this.tableCol.filter((item) => {
      if (!this.checkAccount(item.account)) {
        return false;
      }
      if (!item.show_key) {
        return true;
      }
      if (item.show_key === "show1") {
        return this.isShowMore;
      }
      if (item.show_key === "show2") {
        return this.isShowMore2;
      }
      if (item.show_key === "show3") {
        return this.isShowMore3;
      }
      return true;
    });
  }
  get tableLayoutKey() {
    return `${Number(this.isShowMore)}-${Number(this.isShowMore2)}-${Number(this.isShowMore3)}`;
  }
  get companyName() {
    if (!this.listItem || !this.listItem.company) {
      return "";
    }
    return COMPANY_OPTIONS[this.listItem.company] || this.listItem.company;
  }
  private LSselectedItem = {} as any;
  private tableLoading = false;
  private updateExtendsOptionsCode = null;

  async created() {
    this.inquirySheetId = this.$route.query.id as string;
    this.getINState(this.$route.query.id as string);
    if (this.$route.query.item) {
      let listParam = {
        inquirySheetCode: null,
        customerId: null,
        sellerId: null,
        inquiryStatus: null,
        startTime: null,
        endTime: null,
        time: null,
      };
      listParam.inquirySheetCode = this.$route.query.item

      const params = {
        ...listParam,
        pageNumber: 1,
        pageSize: 1,
      };
      await getInquirySheet(params).then((res:any) => {
        const { list }: any = res
        if(list.length > 0) {
          this.listItem = list[0];
        }
      });
    }
    if (this.$route.query.updateExtendsOptionsCode) {
      this.updateExtendsOptionsCode = this.$route.query.updateExtendsOptionsCode
    }
     if (this.$route.query.inquiryStatus) {
      this.inquiryStatus = this.$route.query.inquiryStatus
    }
    this.init();
  }

  async activated() {
    this.inquirySheetId = this.$route.query.id as string;
    if (this.$route.query.item) {
      let listParam = {
        inquirySheetCode: null,
        customerId: null,
        sellerId: null,
        inquiryStatus: null,
        startTime: null,
        endTime: null,
        time: null,
      };
      listParam.inquirySheetCode = this.$route.query.item

      const params = {
        ...listParam,
        pageNumber: 1,
        pageSize: 1,
      };
      await getInquirySheet(params).then((res:any) => {
        const { list }: any = res
        if(list.length > 0) {
          this.listItem = list[0];
        }
      });
    }
    if (this.$route.query.updateExtendsOptionsCode) {
      this.updateExtendsOptionsCode = this.$route.query.updateExtendsOptionsCode
    }
    this.init();
  }

  private init() {
    this.getList();
    this.getInquirySheetOrderStatus();
    this.getNumberTypes();
    this.getInquirySheetPiPei();
  }

  private async getINState(id) {
    const res: any = await getInquirySheetState(id);
    if (res.prompt) {
      this.$notify({
        title: "提示",
        message: res.remark,
        type: "warning",
      });
    }
  }

  private handleSuccess() {
    this.showHistory = false;
    this.clearTableSelection();
    this.getList();
  }

  public querySearch(data) {
    this.table.pageNumber = 1;
    this.listParam = data && data !== "reset" ? data : {};
    delete this.listParam.customerAbbreviation;
    delete this.listParam.hqProductName;
    this.getList();
  }

  private getProductNumberExtendsLoading = false;
  private async getProductNumberExtends() {
    this.getProductNumberExtendsLoading = true;
    await getProductNumberExtends(this.inquirySheetId).then(res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.getProductNumberExtendsLoading = false;
    }).catch(err => {
      console.log(err);
      this.getProductNumberExtendsLoading = false;
    })
  }

  public handleCommand(command) {
    this[command]();
  }

  public handleCommandWithHaveParam(command) {
    this[command.method](command.param);
  }

  // 包装资料-匹配
  public async matchPacking() {
    this.$notify({
      title: "成功",
      message: "提交成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 包装资料-导出
  public async exportPacking() {
    await exportInquirySheetPackageInfo({
      id: this.inquirySheetId,
    });
    this.$notify({
      title: "成功",
      message: "导出成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  //  删除
  public async handleDelete(scope) {
    await deleteInquirySheetDetail(scope.row.detailId);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.handleSuccess();
  }

  // 下载历史报价单
  public async handleHistory(scope) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    if (scope.row.productNumberId) {
      this.LSselectedItem = scope.row;
      (this.$refs.historyREF as any).getListCreate(scope.row).then(res => {
        this.showHistory = true;
        loading.close();
      }).catch(err => {
        console.log(err);
        loading.close();
      });
    } else {
      this.$notify({
        title: "提示",
        message: "该产品没有历史报价单",
        type: "warning",
      });
      loading.close();
    }
  }

  // 填写备注
  public async handleRemark(item) {
    let data = {
      remark: item.remark,
    };
    await addInquirySheetRemark(item.detailId, data);
    this.$notify({
      title: "成功",
      message: "创建成功",
      type: "success",
      duration: 2000,
    });
    //新增成功以后在做一次查询
    await this.getList();
  }

  // 查看草稿
  private async viewDraft() {
    this.$router.push({
      path: `/proformaInvoiceDraft`,
      query: {
        id: this.inquirySheetId,
        code: this.listItem.code,
        customerId: this.listItem.customerId
      },
    });
  }

  // 导出详情
  public async exportInquirySheetDetail(accountTypeByOperation:string) {
    this.saveDownloadLoading = true;
    this.$confirm("您需要什么形式的下载", "提示", {
      confirmButtonText: "全部下载",
      cancelButtonText: "勾选下载",
      distinguishCancelAndClose: true,
      type: "success",
    })
      .then(async (e) => {
        await exportInquirySheetDetail(this.inquirySheetId, accountTypeByOperation)
          .then((res) => {
            this.saveDownloadLoading = false;
          })
          .catch((err) => {
            this.saveDownloadLoading = false;
          });
      })
      .catch(async (err) => {
        if (err === "cancel") {
          let NewArrKeyName = Object.keys(this.selectedRowsOBJ);
          let NewArr = NewArrKeyName.map((item) => {
            return this.selectedRowsOBJ[item];
          });
          let lists: any = NewArr.reduce((a, b) => a.concat(b));
          if (lists.length !== 0) {
            let detailIds = lists.map((ti) => {
              return ti.detailId;
            });
            await downloadCheckQuotation(detailIds)
              .then((res) => {
                this.$notify({
                  title: "提示",
                  message: "导出成功",
                  type: "success",
                  duration: 2000,
                });
                this.clearTableSelection();
                this.saveDownloadLoading = false;
              })
              .catch((err) => {
                console.log(err);
                this.clearTableSelection();
                this.saveDownloadLoading = false;
              });
          } else {
            this.$notify({
              title: "提示",
              message: "请选择数据",
              type: "warning",
              duration: 2000,
            });
            this.saveDownloadLoading = false;
          }
        } else {
          this.saveDownloadLoading = false;
        }
      });
  }

  // 保存报价
  private async saveInquirySheetDetail() {
    this.$confirm("保存报价后，以下数据会覆盖为当前数值，请谨慎确认：1、所有号码  2、价格  3、产品属性/描述/车型/工艺   4、产品备注", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(async () => {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.saveBJLoading = true;

      await constcheckWhetherItCanBeSaved(this.inquirySheetId).then(async () => {
        await saveInquirySheetDetail(this.inquirySheetId)
        .then(() => {
          this.saveBJLoading = false;
          this.$notify({
            title: "成功",
            message: "保存报价成功",
            type: "success",
            duration: 2000,
          });
          this.getList();
          loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.saveBJLoading = false;
          loading.close();
        });
      }).catch(err => {
        console.log(err);
        this.saveBJLoading = false;
        loading.close();
      })
    })
    .catch((err) => {
      console.error(err);
    });
  }

  //  生成PI草稿 需要校验PI是否存在相同产品
  private createInquirySheetPI(accountTypeByOperation:string) {
    let NewArrKeyName = Object.keys(this.selectedRowsOBJ);
    let NewArr = NewArrKeyName.map((item) => {
      return this.selectedRowsOBJ[item];
    });
    let lists: any
    if (NewArr.length > 0) {
     lists  = NewArr.reduce((a, b) => a.concat(b));
    }else {
      lists = [];
    }
    this.$confirm("再次生成将会覆盖上次草稿，确定要生成吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
        .then(async () => {
       const inquirySheetDetailIds = lists.map((item) => item.detailId);
        const params = {
          inquirySheetId: this.inquirySheetId,
          inquirySheetDetailIds,
          accountTypeByOperation:accountTypeByOperation
        };
        await createInquirySheetPI(params);
        this.selectedRowsOBJ = {};
        this.$router.push({
          path: `/proformaInvoiceDraft`,
          query: {
            id: this.inquirySheetId,
            code: this.listItem.code,
            inquirySheetDetailIds: inquirySheetDetailIds.join(","),
            customerId: this.listItem.customerId,
          },
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private noticeFuGai() {
    const { id, customerId, customerAbbreviation } = this.listItem;
    this.showNotice = false;
    this.$router.push({
      path: `/formUploadTool?id=${id}&customerId=${customerId}&customerAbbreviation=${customerAbbreviation}&type=updateInquirySheet&replace=true&updateExtendsOptionsCode=${this.updateExtendsOptionsCode}&accountTypeOperation=${this.updateInquirySheetByUploadAccountType}`,
    });
  }

  private noticeUpdate() {
    const { id, customerId, customerAbbreviation } = this.listItem;
    this.showNotice = false;
    this.$router.push({
      path: `/formUploadTool?id=${id}&customerId=${customerId}&customerAbbreviation=${customerAbbreviation}&type=updateInquirySheet&replace=false&updateExtendsOptionsCode=${this.updateExtendsOptionsCode}&accountTypeOperation=${this.updateInquirySheetByUploadAccountType}`,
    });
  }

  // 上传维护报价
  private async handleUploadQuotation(accountTypeByOperation:string) {
    this.showNotice = true;
    this.updateInquirySheetByUploadAccountType = accountTypeByOperation;
  }

  private async getNumberTypes() {
    const res: any = await getNumberTypes();
    this.searchForm[1].options = res;
    this.FormItem[0].options = res.map((item) => {
      return {
        ...item,
        value: item.id,
      };
    });
  }

  private async getInquirySheetOrderStatus() {
    const res: any = await getInquirySheetOrderStatus();
    this.searchForm[3].options = res;
  }

  private async getInquirySheetPiPei() {
    const res: any = await getInquirySheetPiPei(this.inquirySheetId);
    if (res.data) {
      this.createPITrue = false;
    } else {
      this.createPITrue = true;
    }
  }

  private async getList(ReloadButton=true) {
    this.tableLoading = true;
    if(ReloadButton) {
      this.isShowMore = false;
      this.isShowMore2 = false;
      this.isShowMore3 = false;
    }
    const params = {
      ...this.listParam,
      inquirySheetId: this.inquirySheetId,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    await getInquirySheetDetail(params)
      .then((res) => {
        const { total, list }: any = res;
        list.forEach((item) => {
          item.selectable = !item.approvalRecordId;
        });
        this.table.total = +total;
        list.map((item) => {
          if (
            item.conversionProfitMargin &&
            item.conversionProfitMargin.indexOf("%") > -1
          ) {
            item.conversionProfitMargin = (
              parseInt(item.conversionProfitMargin.replace("%", "")) / 100
            ).toFixed(2);
          }
        });
        if (list.length > 0) {
          list[0].models.forEach((e, index) => {
            let newObj = {
              label: e.typeName,
              prop: "num" + index,
              key: "num" + index,
              type: "productNumber",
              show: true,
              disabled: false,
              show_key: "show1",
              width: 110,
              typeId: e.typeId,
            };
            if (
              this.tableCol.findIndex((elm) => elm.key === newObj.key) === -1
            ) {
              this.tableCol = this.changeArr(this.tableCol, 3, newObj);
            }
          });
        }
        if (list.length > 0) {
          list.map((item) => {
            if (item.models.length > 0) {
              item.models.forEach((res, num) => {
                item[`num${num}`] = res.number;
              });
            }
          });
        }
        this.table.list = list;
        this.clearTableSelection();
        this.restoreSelection();
        this.tableLoading = false;
        this.relayoutTable();
      })
      .catch((err) => {
        this.tableLoading = false;
        console.log(err);
      });
  }
  private changeArr(arrayList, index, value) {
    arrayList.splice(index, 0, value);
    return arrayList;
  }

  // 点击是否展示所有产品号码
  private async showMore() {
    if (this.table.list.length === 0) {
      return;
    }
    this.isShowMore = !this.isShowMore;
    this.relayoutTable();
  }

  private async showMore2() {
    if (this.table.list.length === 0) {
      return;
    }
    this.isShowMore2 = !this.isShowMore2;
    this.relayoutTable();
  }

  private async showMore3() {
    if (this.table.list.length === 0) {
      return;
    }
    this.isShowMore3 = !this.isShowMore3;
    this.relayoutTable();
  }

  private relayoutTable() {
    this.$nextTick(() => {
      const table = this.$refs.table as any;
      if (table && table.doLayout) {
        table.doLayout();
      }
      this.restoreSelection();
    });
  }

  private selectedRowsOBJ = {} as any;

  private checkAccount(exceptAccounts?: string[] | string) {
    if (!exceptAccounts) {
      return true;
    }
    const userAccounts = UserModule.accountType || [];
    if (Array.isArray(exceptAccounts)) {
      return userAccounts.some((item) => exceptAccounts.includes(item));
    }
    return userAccounts.includes(exceptAccounts);
  }

  private checkSelectable(row) {
    return row.selectable;
  }

  private hasProductNumber(row, column) {
    return this.getProductNumbers(row[column.prop]).length > 0;
  }

  private getProductNumbers(value) {
    if (value === null || value === undefined || value === "") {
      return [];
    }
    return String(value)
      .split("\n")
      .map((item) => item.trim())
      .filter((item) => item !== "");
  }

  private openPiHistoryPrice(row, column, number?: string) {
    const numbers = this.getProductNumbers(row[column.prop]);
    const selectedNumber = number || numbers[0];
    if (!selectedNumber) {
      return;
    }
    const index = Number(String(column.prop).replace("num", ""));
    const model = Array.isArray(row.models) ? row.models[index] : null;
    this.piHistoryMeta = {
      numberType: (model && model.typeName) || column.label || "",
      number: selectedNumber,
    };
    this.piHistoryQuery = {
      inquirySheetId: this.inquirySheetId,
      detailId: row.detailId,
      numberTypeId: model && (model.typeId || model.id),
      number: selectedNumber,
      customerId: this.listItem.customerId,
    };
    this.showPiHistoryPrice = true;
  }

  private handleTableAction(click: string, scope) {
    if (click === "createModel") {
      this.openDialog(scope);
      return;
    }
    this[click](scope);
  }

  private openRemarkDialog(row) {
    this.editRemarkRow = row;
    this.editRemark = row.remark || "";
    this.showEditRemark = true;
  }

  private async confirmEditRemark() {
    await this.handleRemark({
      ...this.editRemarkRow,
      remark: this.editRemark,
    });
    this.showEditRemark = false;
  }

  private clearTableSelection() {
    const table = this.$refs.table as any;
    if (table && table.clearSelection) {
      table.clearSelection();
    }
  }

  private restoreSelection() {
    const selected = this.selectedRowsOBJ[`index${this.table.pageNumber}`];
    if (!selected || selected.length === 0) {
      return;
    }
    this.$nextTick(() => {
      const table = this.$refs.table as any;
      if (!table) {
        return;
      }
      selected.forEach((row) => {
        const matched = this.table.list.find((item) => item.detailId === row.detailId);
        if (matched) {
          table.toggleRowSelection(matched, true);
        }
      });
    });
  }

  private handleSelectionChangeOne(rows) {
    this.selectedRowsOBJ[`index${this.table.pageNumber}`] = rows;
  }

  private handleSelectionChangeAll(rows) {
    this.selectedRowsOBJ[`index${this.table.pageNumber}`] = rows;
  }

  private async handlerSeeRemark(row) {
    this.productNumberId = row.row.detailId
    const res = await getExtend(row.row.detailId)
    this.remarkInfo = res
    this.show_remark = true
  }

  private removeRemark(index) {
    this.remarkInfo.splice(index,1)
  }

  private addRemark() {
    this.remarkInfo.push({id: null,type: '',value: ''})
  }

  private  getCurrentAccountType():string {
   return  UserModule.accountType[0];
  }
}
